import React, { useState } from 'react';
import { getContentIdFromContentUrl } from  '@/components/elements/search/utility';
import { getViewerCount, resetViewCount } from '@/api/displayInformationModal';


const UseDisplayInformationPopUpModal = () => {
    const [userCount, setUserCount]=useState<string>("");
    const listId = getContentIdFromContentUrl(window.location.href);

    function onShowModalClick() {
        getUserCount();
    }

    function onCloseClick() {
        setUserCount("");
    }
    
    function onConfirmClick() {
        resetViews();
        onCloseClick();
    }

    function getUserCount() {
        getViewerCount(listId)
        .then((data) => {
            const userCount = data.viewCount;
            if (userCount === 1) {
                setUserCount("1 user");
            } else {
                setUserCount(`${userCount || 0} users`)
            } 
        })
        .catch((err) => {
            console.error(err);
        })
    }

    function resetViews() {
        resetViewCount(listId);
    }

    return {
        showModal: userCount,
        userCount, 
        onCloseClick, 
        onConfirmClick,
        onShowModalClick
    }
}

export default UseDisplayInformationPopUpModal;